import ApiService from "../../../services/api";
import moment from "moment";
import helpers from "../../../shared/fleetbox-helpers";
import property from '../chartProperties';

export default {
	data: function() {
		return {
			/* AVG fuel consumption */
			pdfOptions: {
				landscape: true,
				fileName: "Consumo Medio",
				title: "Consumo Medio"
			},
			avgConsumptionModal: false,
			avgFuelConsumption: [
				{
					name: "Consumo Medio",
					field: "value",
					labels: {
						visible: true,
						background: "none",
						format: "n2",
						font: "10px montserrat-light"
					},
					markers: {
						background: property.avgConsumption.colorDot
					},
					color: property.avgConsumption.colorLine
				}
			],
			avgFuelConsumptionData: [],
			legend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var color = property.avgConsumption.colorDot; //e.options.markers.background;
						var labelColor = e.options.labels.color;
						var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name, [0, 0], {
							fill: {
								color: labelColor
							},
							font: "13px 'Montserrat Light', montserrat-light !important"
						});

						layout.append(marker, label);
						layout.reflow();

						return layout;
					}
				}
			},
			avgFuelConsumptionTooltip: {
				visible: true,
				template: "Consumo medio dal #= dataItem.from # al #= dataItem.to #: #= kendo.toString(value, 'n2') # l/100km"
			},
			avgFuelConsumptionCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			avgFuelConsumptionValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						rotation: "auto",
						visible: false,
						font: "10px montserrat-light"
					}
				}
			],
			avgFuelConsumptionValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						rotation: 0,
						text: "l/100Km",
						font: "10px montserrat-light"
					},
					labels: {
						format: "n0",
						font: "10px montserrat-light"
					}
				}
			],
			avgConsumptionModalIndex: 0,
			modalTitle: "Consumo medio",
			loading: true
			/* AVG fuel consumption */
		};
	},
	watch: {},
	created() {
		this.getTripsCounter();
	},
	methods: {
		avgConsumptionModalClickHandler() {
			this.avgConsumptionModal = true;
			$(".k-tooltip.k-chart-tooltip").remove();
			setTimeout(() => {
				this.avgConsumptionModalIndex++;
			}, 200);
		},
		/* Trips Counter */
		getTripsCounter() {
			var self = this;
			ApiService.getTripsCounter().then(res => {
				self.getUserFriendlyTripsCounter(res);
			});
		},

		getUserFriendlyTripsCounter(data) {
			var self = this;

			if (data && data.length > 0) {
				var maxAvgFuelComsumptionValue = _.maxBy(data, function(o) {
					return Math.abs(o.values.avg_fuel_consumption);
				}).values.avg_fuel_consumption;
				var maxDate = _.maxBy(data, function(o) {
					return moment(o.to);
				}).to;

				var minDate = _.minBy(data, function(o) {
					return moment(o.from);
				}).from;

				this.modalTitle = `Consumo medio dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))} (settimanale)`;
				this.pdfOptions.title = `Consumo medio dal ${this.$options.filters.dateToString(moment(minDate))} al ${this.$options.filters.dateToString(moment(maxDate))}`;
				this.pdfOptions.fileName = helpers.chartPdffileName(this, "Consumo_medio", minDate, maxDate);

				data.forEach(function(item) {
					var pavgFuelConsumption = (Math.abs(item.values.avg_fuel_consumption) * 100) / Math.abs(maxAvgFuelComsumptionValue);
					var percentageavgFuelConsumption = pavgFuelConsumption / 100;
					var coloravgFuelConsumptionValue = property.avgConsumption.colorDot;//self.pickHex([125, 125, 125], [184, 184, 184], percentageavgFuelConsumption);

					self.avgFuelConsumptionCategoryAxis.categories.push(self.$options.filters.dateToString(item.from));
					self.avgFuelConsumptionData.push({
						from: self.$options.filters.dateToString(item.from),
						to: self.$options.filters.dateToString(item.to),
						value: item.values.avg_fuel_consumption ? item.values.avg_fuel_consumption : 0,
						color: coloravgFuelConsumptionValue
					});
				});
			}

			setTimeout(function() {
				self.loading = false;
			}, 200);
		},
		/* Trips Counter */

		//#region Utils
		pickHex(color1, color2, weight) {
			var w1 = weight;
			var w2 = 1 - w1;
			var rgb = [Math.round(color1[0] * w1 + color2[0] * w2), Math.round(color1[1] * w1 + color2[1] * w2), Math.round(color1[2] * w1 + color2[2] * w2)];
			return rgb;
		},

		createChart(container, exportOptions) {
			var self = this;

			var options = {
				pdf: self.pdfOptions,
				theme: "metro",
				title: {
					text: self.modalTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					visible: true,
					position: "bottom",
					item: {
						visual: function(e) {
							var color = property.avgConsumption.colorDot; //e.options.markers.background;
							var labelColor = e.options.labels.color;
							var rect = new kendo.geometry.Rect([0, 0], [200, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name, [0, 0], {
								fill: {
									color: labelColor
								},
								font: "13px 'Montserrat Light', montserrat-light"
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefaults: {
					type: "line",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.avgFuelConsumptionData
				},
				series: [
					{
						field: "value",
						name: "CONSUMO MEDIO",
						labels: {
							visible: true,
							font: "13px montserrat-light",
							format: "n2"
						},
						markers: {
							background: property.avgConsumption.colorDot
						},
						color: property.avgConsumption.colorLine
					}
				],
				valueAxis: {
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "L/100KM",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						font: "13px montserrat-light",
						format: "n0"
					}
				},
				categoryAxis: {
					categories: self.avgFuelConsumptionCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			container.kendoChart(options);
		},

		exportAsPdf() {
			// var chart = this.$refs.chartAvgConsumptionModal.kendoWidget();
			// chart.saveAsPDF();

			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				// Custom settings for export
				transitions: false,

				// Cleanup
				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},
		exportAsXlsx(type) {
			var self = this;
			ApiService.exportAnalyticsXlsx("fuel", type).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Consumo medio.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		//#endregion
	}
};
